import React, { useState, FormEvent } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { resetPassword } = useAuth();

  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const inputClass =
    'appearance-none block w-full px-3 py-2 border border-stake-border rounded-md shadow-sm placeholder-gray-500 bg-dark-200 text-white focus:outline-none focus:ring-stake-blue focus:border-stake-blue sm:text-sm';

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    if (!token) {
      setError('קישור לאיפוס סיסמא לא תקין');
      return;
    }
    if (password.length < 8) {
      setError('הסיסמא חייבת להכיל לפחות 8 תווים');
      return;
    }
    if (password !== confirm) {
      setError('הסיסמאות אינן תואמות');
      return;
    }

    setLoading(true);
    const res = await resetPassword(token, password);
    setLoading(false);

    if (res.success) {
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2500);
    } else {
      setError(res.message || 'שגיאה באיפוס הסיסמא');
    }
  };

  return (
    <div className="flex min-h-screen flex-col justify-center py-12 sm:px-6 lg:px-8 bg-dark-200">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-2xl font-extrabold text-white">איפוס סיסמא</h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md m-2">
        <div className="bg-dark-300 py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {success ? (
            <div className="text-center space-y-4">
              <p className="text-green-400">הסיסמא עודכנה בהצלחה! מועבר לדף ההתחברות...</p>
              <Link to="/login" className="text-stake-blue hover:text-stake-blue-light text-sm">
                לחץ כאן אם לא הועברת אוטומטית
              </Link>
            </div>
          ) : (
            <form className="space-y-6" onSubmit={handleSubmit}>
              {!token && (
                <p className="text-stake-red text-sm text-center">קישור לאיפוס סיסמא לא תקין או פג תוקף.</p>
              )}
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">סיסמא חדשה</label>
                <input
                  type="password"
                  required
                  minLength={8}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={inputClass}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">אימות סיסמא</label>
                <input
                  type="password"
                  required
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className={inputClass}
                />
              </div>
              {error && <p className="text-stake-red text-sm">{error}</p>}
              <button
                type="submit"
                disabled={loading || !token}
                className="w-full py-2 px-4 rounded-md text-sm font-medium text-white bg-stake-blue hover:bg-stake-blue-dark focus:outline-none focus:ring-2 focus:ring-stake-blue disabled:opacity-50"
              >
                {loading ? 'מעדכן...' : 'עדכן סיסמא'}
              </button>
              <div className="text-center">
                <Link to="/login" className="text-sm text-stake-blue hover:text-stake-blue-light">
                  חזרה להתחברות
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
